import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState } from '../shared';
import './RecentActivityFeed.css';

/**
 * RecentActivityFeed Component
 * Displays recent compliance-related activities
 */
const RecentActivityFeed = ({ activities }) => {
  if (!activities || activities.length === 0) {
    return (
      <div className="recent-activity-feed">
        <div className="recent-activity-feed__header">
          <h3 className="recent-activity-feed__title">Recent Activity</h3>
        </div>
        <EmptyState
          title="No recent activity"
          description="Compliance activities will appear here"
        />
      </div>
    );
  }

  const STATUS_LABEL_MAP = {
    'pending_a2p_trust_product': 'waiting for trust product approval',
    'pending_trusthub': 'waiting for business profile approval',
    'twilio-approved': 'approved',
    'twilio-rejected': 'rejected',
    'pending-review': 'pending review',
    'in-review': 'in review',
  };

  const formatDescription = (description) => {
    if (!description) return description;
    return Object.entries(STATUS_LABEL_MAP).reduce(
      (text, [raw, label]) => text.replace(new RegExp(raw.replace(/_/g, '[_-]'), 'gi'), label),
      description
    );
  };

  const getActivityColor = (type) => {
    const colorMap = {
      created: '#10b981',
      updated: '#3b82f6',
      approved: '#059669',
      rejected: '#ef4444',
      pending: '#f59e0b',
      default: '#64748b',
    };
    return colorMap[type] || colorMap.default;
  };

  return (
    <div className="recent-activity-feed">
      <div className="recent-activity-feed__header">
        <h3 className="recent-activity-feed__title">Recent Activity</h3>
        <span className="recent-activity-feed__count">
          {activities.length} {activities.length === 1 ? 'item' : 'items'}
        </span>
      </div>

      <div className="recent-activity-feed__list">
        {activities.map((activity, index) => (
          <div key={index} className="activity-item">
            <div
              className="activity-item__indicator"
              style={{
                backgroundColor: getActivityColor(activity.type),
              }}
            />
            <div className="activity-item__content">
              <p className="activity-item__description">{formatDescription(activity.description)}</p>
              <span className="activity-item__time">{activity.relative_time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

RecentActivityFeed.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      relative_time: PropTypes.string.isRequired,
      type: PropTypes.string,
      category: PropTypes.string,
    })
  ),
};

export default RecentActivityFeed;
